<template>
  <div class="container" draggable="false">
    <!-- 服务顾问弹窗 -->
    <div class="dialog">
      <div class="avatar-wrapper">
        <img :src="adviser.avatar" class="avatar" alt="" />
      </div>
      <div class="name">{{ adviser.guideName }}</div>
      <div class="shopname">{{ adviser.networkName }}</div>
      <div>
        <img draggable="false" class="qrcode" :src="adviser.qrCodeUrl || 'https://market-cdn.anoah.com/dm/static/market-h5-smartguide/guide_code_error.png'" @touchstart="touchstart" @touchend="touchend" />
      </div>
      <div class="qrcode-hint" v-if="sourceType === 'machine'">长按识别二维码 添加企微好友向TA询价</div>
      <div class="qrcode-hint" v-else>长按识别二维码 添加企微好友获取更多课程</div>
    </div>
  </div>
</template>
<script>

import {
  trackerConfig,
  PAGE_EXPOSE,
  BUTTON_CLICK,
  ELEMENT_EXPOSE,
} from "../../utils/bigDataSdk";
import * as apis from "../../axios/PublicLink/index";
import { formatterPoint } from "../../utils/tools";
import * as config from '../../axios/config'
export default {
  data: () => {
    return {
      adviser: {},
      sourceType: ''
    };
  },
  mounted() {
    const query = this.$route.query || {}
    const {
      sourceType: sourceType,
      isSignin: isSignin,
      subjectName,
      firstNavi,
      submitDetail,
      channelCode,
      fromResourceId,
      fromResourceName,
      fromContent,
      adviser
    } = query;
    this.adviser = JSON.parse(adviser)
    this.sourceType = sourceType
    // 获取推荐导购信息
    this.tracker = trackerConfig({
      pageName: "导购二维码页",
      pageId: "70007",
      isSignin: isSignin,
      firstNavi: firstNavi || null,
      subject: subjectName || null,
      submitDetail: submitDetail || null,
      fromContent: fromContent || null,
      fromButtonName:this.sourceType === 'machine' ? '购机咨询' : '点击领取'
    }, {
      app_key: '7bea62d8-928c-4ea1-997d-4f3217c0628a',
      appinfo: {
        _package_name: 'com.anoah.gylj',
        _platform_type: 'wxpub',
        _app_name: '公益链接',
      },
      deviceinfo: {
        _ProductID: '2022121410395012345'
      }
    });
    this.$toast(`询价提交成功 你也可添加顾问企微快速联系`)
    setTimeout(() => {
      this.tracker({
        eventKey: 'PAGE_EXPOSE',
        fromPage: {
          pageId: '70006',
          pageName: '购机咨询页面'
        },
        pageGuideId: this.adviser.guideId || null,
        pageGuideName: this.adviser.guideName || null,
        fromContent: fromContent || null,
        fromButtonName:this.sourceType === 'machine' ? '购机咨询' : '点击领取'
      });
    }, 200)
  },
  methods: {
    touchstart() {

      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.longPress();
      }, 300);
    },
    touchend() {
      clearTimeout(this.timer);
    },
    // 长按统计
    longPress() {
      this.tracker({
        eventKey: 'ELEMENT_LONG_CLICK',
        elementType: '页面',
        elementName: '导购二维码页',
        elementGuideId: this.adviser.guideId,
        elementGuideName: this.adviser.guideName,
        resourceId: this.$route.query.fromResourceId || null,
        resourceName: this.$route.query.fromResourceName || null,
        fromContent: this.$route.query.fromContent || null,
        fromButtonName:this.sourceType === 'machine' ? '购机咨询' : '点击领取'
      });
    },
  }

};
</script>
<style lang="scss" scoped>
.container {
  background: url(../../assets/bg.png) no-repeat 46%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog {
  width: 275px;
  height: 350px;
  background: #ffffff;
  box-shadow: -5px 9px 10px 0px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  position: relative;
}

.avatar-wrapper {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  width: 66px;
  height: 66px;
  border-radius: 50%;

}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  // margin-top: 20px;
  background: url(../../assets/man-avatar.png);
  background-position: center center;
  background-size: 60px 60px;
}

.name {
  margin-top: 30px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.shopname {
  font-size: 14px;
  color: #999;
}

.qrcode {
  margin-top: 20px;
  width: 150px;
  height: 150px;
}

.qrcode-hint {
  margin-top: 15px;
  font-weight: 500;
  color: #999999;
  font-size: 13px;
}
</style>
  